module.exports = __webpack_public_path__ + "img/HK.4097e778.png";